<template>
  <section class="image-bg container-fluid py-6 py-md-8" id="about-hero">
    <div class="video" :class="{'open': videoOpen}">
      <video controls>
        <source src="@/assets/csca-knot.mp4" type="video/mp4">
      Your browser does not support the video tag.
      </video>
            <div class="close-video text-center" @click="closeVideo()"><img src="@/assets/close-icon.svg" alt="Close Video"> Close</div>

    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-11 col-lg-10 col-xl-9">
        <h1 class="white-text text-md-center load-anim" ref="headline">
          About CS Capital Advisors
        </h1>
        <h2
          class="sub-head gold-text mb-5 mb-md-6 text-md-center load-anim"
          ref="subhead"
        >
          Financial Advisory and Asset Management
        </h2>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-2 mb-4 mb-md-0 load-anim" ref="sidenav">
        <p class="bold-text white-text mb-1">Learn More About</p>
        <ul>
          <li>
            <router-link :to="{ name: 'Leadership' }">Leadership</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'Careers' }">Careers</router-link>
          </li>

          <li>
            <router-link :to="{ name: 'Contact' }">Contact</router-link>
          </li>
          <li>
            <a href="#csca-knot" @click.prevent="showVideo()">Origin of Our Logo</a>
          </li>
        </ul>
      </div>
      <div class="col-12 col-md-8 col-lg-7 col-xl-6 load-anim" ref="content">
        <p>
          Founded in 1999, CS Capital Advisors provides independent financial
          advisory and value-add asset management services to the healthcare and
          commercial real estate industries and related service sectors. With a
          proven long-term track record and unparalleled industry experience,
          CSCA is the trusted partner to assist owners, operators and investors
          in achieving their objectives and maximizing value.
        </p>
        <p>
          We distinguish ourselves by our willingness to take on challenging
          assignments, our history of producing creative solutions to complex
          situations and our commitment to provide clients with unbiased
          practical advice. Our independent platform enables us to focus our
          efforts solely on serving the needs of our clients.
        </p>
      </div>
      <div class="col-12 col-lg-10">
        <CSCAstats whitetext autoload class="load-anim" ref="stats" />
      </div>
    </div>
  </section>
</template>

<script>
import CSCAstats from "@/components/CSCAstats.vue";
import { TimelineLite, TweenLite, Power2 } from "gsap";
// eslint-disable-next-line no-unused-vars
import ScrollToPlugin from "gsap/ScrollToPlugin";
export default {
  components: {
    CSCAstats
  },
  data() {
    return {
      videoOpen: false
    }
  },
  methods: {
    introAnim() {
      var introAnimEls = [];
      introAnimEls.push(this.$refs.headline);
      introAnimEls.push(this.$refs.subhead);
      introAnimEls.push(this.$refs.content);
      introAnimEls.push(this.$refs.sidenav);
      introAnimEls.push(document.getElementById("csca-stats"));
      var t1 = new TimelineLite();
      t1.staggerTo(
        introAnimEls,
        1,
        { opacity: 1, transform: "translateY(0)", ease: Power2.easeOut },
        0.3,
        "-=0.2"
      );
    },
    scrollLink(target) {
      TweenLite.to(window, 1, {
        scrollTo: target,
        ease: Power2.easeOut
      });
    },
    showVideo() {
      this.videoOpen = true
    },
    closeVideo() {
      this.videoOpen = false
    }
  },
  mounted() {
    this.introAnim();
  }
};
</script>

<style lang="scss" scoped>
#about-hero {
  background-image: url(../assets/manhattan-bg.jpg);
}
p {
  color: #ffffff;
  &.bold-text {
    text-transform: uppercase;
  }
}
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
a {
  color: #dcb249;
  text-decoration: none;
  transition: all 0.3s ease;
  &:hover {
    color: #ffffff;
    text-decoration: underline;
  }
}

.video {
  position: fixed;
  z-index: -1000;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #111D3C;
  opacity: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all .5s ease;
  &.open {
    z-index: 1000;
    opacity: 1;
  }
  .close-video {
    margin-top: 2rem;
    text-transform: uppercase;
    color: #dcb249;
    cursor: pointer;
  }
  video {
    width: 95%;
    max-width: 1000px;
    height: auto;
  }
}
</style>
